var image_upload_default = {
  "container": "BfdsV",
  "disabled": "RuO-d",
  "imageInput": "_91Zxf",
  "overlay": "NSolU",
  "text": "_7dvCj",
  "shown": "cC-lU",
  "hide": "HBwDT",
  "spinner": "Usbb7",
  "spin": "kp-Sh"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
